export default __webpack_public_path__ + "static/media/secured_card.f0d6b8e8.svg";